// extracted by mini-css-extract-plugin
module.exports = {"container":"accordion_container__2XGyZ","title":"accordion_title__vTg9W"};